import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconThermostat = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 -960 960 960' size={size} color={color} aria-hidden='true' {...props}>
    <path
      fill='currentColor'
      d='M560-520q-17 0-28.5-11.5T520-560q0-17 11.5-28.5T560-600h120q17 0 28.5 11.5T720-560q0 17-11.5 28.5T680-520H560Zm0-160q-17 0-28.5-11.5T520-720q0-17 11.5-28.5T560-760h240q17 0 28.5 11.5T840-720q0 17-11.5 28.5T800-680H560ZM178.5-178.5Q120-237 120-320q0-48 21-89.5t59-70.5v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q38 29 59 70.5t21 89.5q0 83-58.5 141.5T320-120q-83 0-141.5-58.5ZM200-320h240q0-29-12.5-54T392-416l-32-24v-280q0-17-11.5-28.5T320-760q-17 0-28.5 11.5T280-720v280l-32 24q-23 17-35.5 42T200-320Z'
    />
  </SDIcon>
)

export default IconThermostat
